(function() {
    const teasers = document.querySelectorAll(".page-teaser");
    teasers.forEach(teaser => {
        const link = teaser.querySelector(".page-teaser__title");
        if (link && link.getAttribute("href")) {
            teaser.addEventListener("click", () => {
                if (link.getAttribute("target") === "_blank") {
                    window.open(link.getAttribute("href"), "_blank");
                } else {
                    location.assign(link.getAttribute("href"));
                }
            });
        }
    });
})();
